import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../store/slices/ordersSlice";
import Loader from "../../../components/UtilityComponents/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../styles/common.css";

const OrdersList = () => {
  const dispatch = useDispatch();
  const { orders, loading, error } = useSelector((state) => state.adminOrders);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const handleViewClick = (order) => {
    setSelectedOrder(order);
    setViewDialogOpen(true);
  };

  const filteredOrders = orders?.filter((order) =>
    order.order_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
    order.user_email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <Loader />;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container-fluid">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="row mb-4">
        <div className="col-md-6">
          <h1 className="h3">Orders Management</h1>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by order ID or user email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>User Email</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders?.map((order) => (
                  <tr key={order.id}>
                    <td>{order.order_id}</td>
                    <td>{order.user_email}</td>
                    <td>${order.total_amount}</td>
                    <td>
                      <span className={`status-badge ${order.status.toLowerCase()}`}>
                        {order.status}
                      </span>
                    </td>
                    <td>{new Date(order.created_at).toLocaleDateString()}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-view"
                        onClick={() => handleViewClick(order)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* View Order Modal */}
      {viewDialogOpen && selectedOrder && (
        <div className="modal">
          <div className="modal-content">
            <h3>Order Details</h3>
            <div className="order-info">
              <div className="info-group">
                <label>Order ID:</label>
                <span>{selectedOrder.order_id}</span>
              </div>
              <div className="info-group">
                <label>User Email:</label>
                <span>{selectedOrder.user_email}</span>
              </div>
              <div className="info-group">
                <label>Total Amount:</label>
                <span>${selectedOrder.total_amount}</span>
              </div>
              <div className="info-group">
                <label>Status:</label>
                <span className={`status-badge ${selectedOrder.status.toLowerCase()}`}>
                  {selectedOrder.status}
                </span>
              </div>
              <div className="info-group">
                <label>Created At:</label>
                <span>{new Date(selectedOrder.created_at).toLocaleString()}</span>
              </div>
              <div className="info-group">
                <label>Shipping Address:</label>
                <span>{selectedOrder.shipping_address}</span>
              </div>
              <div className="info-group">
                <label>Books:</label>
                <div className="order-books">
                  {selectedOrder.books?.map((book, index) => (
                    <div key={index} className="book-item">
                      <span>{book.title}</span>
                      <span>Quantity: {book.quantity}</span>
                      <span>Price: ${book.price}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="info-group">
                <label>Parcels:</label>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Parcel ID</th>
                        <th>Status</th>
                        <th>Tracking Number</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedOrder.parcels?.map((parcel) => (
                        <tr key={parcel.id}>
                          <td>{parcel.parcel_id}</td>
                          <td>
                            <span className={`status-badge ${parcel.status.toLowerCase()}`}>
                              {parcel.status}
                            </span>
                          </td>
                          <td>{parcel.tracking_number || 'N/A'}</td>
                          <td>{new Date(parcel.created_at).toLocaleString()}</td>
                          <td>{new Date(parcel.updated_at).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-view" onClick={() => setViewDialogOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersList; 